import { ErrorResponse } from './../models/error.model';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    cloneReq: any;

    constructor(private authService: AuthService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let headers = request.headers;

        if (!request.url.includes('amazonaws.com') && !request.url.includes('decidir.com')) {
            if (this.authService.getLogged()) {
                headers = headers.append('Authorization', this.authService.getToken());
            }
            if (environment.version) {
                headers = headers.append('x-client-id', 'garantor-bo');
                headers = headers.append('x-client-version', environment.version);
            }
        }

        this.cloneReq = request.clone({
            url: (request.url && request.url.startsWith('/')) ? environment.apiUrl + request.url : request.url,
            headers
        });

        return next.handle(this.cloneReq).pipe(tap(
            _ => {},
            (error: ErrorResponse) => {
                if (error.status === 403) {
                    this.authService.logout();
                    location.reload();
                }
            }
        ));
    }
}
